import React from 'react';
import { useSelector } from 'react-redux';
import { AppContext } from 'src/components/app-context';
import type {
  BreadcrumbsSlice,
  Breadcrumb as BreadcrumbSliceType,
} from '../../../../types';
import type { AppState } from 'src/reducers';
import * as S from './styles';
import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';
import { Link } from 'react-router-dom';

type BreadcrumbType = BreadcrumbSliceType & {
  id: string;
  pathName: string;
};

type BreadcrumbSliceProps = {
  categoryIds?: string[];
} & BreadcrumbsSlice;

const BreadcrumbSlice = ({ items, categoryIds }: BreadcrumbSliceProps) => {
  const { t } = React.useContext(AppContext);

  const activeCampaigns = useSelector((state: AppState) =>
    state.globals.campaignBanners.active.filter(
      (campaign?: { type: string }) => campaign?.type === 'DURING_PROMO_BANNER'
    )
  );

  const breadcrumbs = items
    .map(item => (item?.pathName ? item : undefined))
    .filter(x => x) as BreadcrumbType[];

  return (
    <>
      {!!activeCampaigns?.length && (
        <S.StyledPromoBanner
          className="product-collection-promo-banner"
          banners={activeCampaigns}
          linkParams={{ category: categoryIds?.join('|') }}
        />
      )}
      <S.Breadcrumbs
        containerProps={{
          onClick: (nextPage: string) => {
            trackInternalNavigationClick({
              scope: InternalNavigationScope.BREADCRUMB,
              nextPage,
            });
          },
        }}
      >
        <Link data-test="Crumb" to="/">
          {t('common', 'breadcrumb.home')}
        </Link>
        {breadcrumbs.map((breadcrumb, index) =>
          index === breadcrumbs.length - 1 ? (
            <span data-test="Crumb" key={breadcrumb.pathName}>
              {breadcrumb.name}
            </span>
          ) : (
            <Link
              data-test="Crumb"
              key={breadcrumb.pathName}
              to={breadcrumb.pathName}
            >
              {breadcrumb.name}
            </Link>
          )
        )}
      </S.Breadcrumbs>
    </>
  );
};

export default BreadcrumbSlice;
